import React from 'react';

import { Box, HStack, Link } from '@chakra-ui/react';
import { isEmpty } from 'lodash';
import round from 'lodash/round';
import { colorOpacity, customTheme } from 'theme';

import {
  CustomTooltip,
  EllipsisText,
  formatLink,
  formatTooltip,
  OrderedList,
  PlusCountTag,
  Tag,
} from 'components/DataDisplay';
import { limitedString } from 'utils/string';

export const renderCVEReferences = (data, onOpen) => {
  return isEmpty(data?.references) ? (
    'None'
  ) : (
    <HStack>
      {data?.references?.[0] && (
        <CustomTooltip label={data?.references?.[0]}>
          <Link href={data?.references?.[0]} target="_blank">
            <Box color="primary" cursor="pointer">
              {limitedString(formatLink(data?.references?.[0]), 12)}
            </Box>
          </Link>
        </CustomTooltip>
      )}
      {data?.references?.length > 1 && (
        <PlusCountTag
          count={data?.references?.length - 1}
          onClick={onOpen}
          cursor="pointer"
        />
      )}
    </HStack>
  );
};

export const renderCVEPatchStatus = row => {
  const color = !row?.fixed_in_version
    ? customTheme.colors.critical
    : customTheme.colors.green['300'];
  return (
    <Tag
      label={row?.fixed_in_version ? 'Patch Available' : 'No Patch'}
      styles={{
        tag: {
          bg: colorOpacity(color, 0.1),
          border: 'none',
          borderRadius: 'full',
        },
        label: { color },
      }}
    />
  );
};

export const renderCVSSScore = row => {
  return row?.cvss_score || row?.cvss_v3?.score
    ? renderCVSSScoreTag(
        round(row?.cvss_score ?? row?.cvss_v3?.score, 1),
        row?.severity,
      )
    : '-';
};

export const renderCVSSScoreTag = (score, severity = 'critical') => {
  const color = customTheme.colors[severity?.toLowerCase()];
  return (
    <Box>
      <Tag
        label={score}
        styles={{
          label: { color },
          tag: {
            border: 'none',
            bg: colorOpacity(color, 0.1),
            py: '2px',
            fontSize: 'md',
          },
        }}
      />
    </Box>
  );
};

export const renderCVEPackageName = row =>
  !!row?.package_name || !!row?.packages || !isEmpty(row?.package_names) ? (
    <EllipsisText
      tooltip={
        row?.package_name ??
        formatTooltip({
          header: 'Packages',
          content: <OrderedList list={row?.packages ?? row?.package_names} />,
        })
      }
    >
      {row?.package_name ??
        row?.packages?.join(', ') ??
        row?.package_names?.join(', ') ??
        '-'}
    </EllipsisText>
  ) : (
    '-'
  );
